import * as React from "react";
import "./Autocomplete.css";

import Suggestions, { Suggestion } from "../Suggestions/Suggestions";
import Input from "../Input/Input";
import classNames from "classnames";
import useOutsideClick from "../../hooks/useOutsideClick";

interface AutocompleteProps {
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  suggestions: Array<Suggestion>;
  onSelect: (suggestion: Suggestion) => void;
  onCloseSuggests?: () => void;
  inputValue?: string;
  suggestionRenderer?: (suggestion: Suggestion) => React.ReactNode;
}

// Это автокомплит для поиска игроков, если нужно будет переиспользовать логику
// создать новый и перенести
const Autocomplete = React.memo(
  ({
    className,
    inputClassName,
    placeholder,
    onChange,
    suggestions,
    onSelect,
    onCloseSuggests,
    inputValue,
    suggestionRenderer,
  }: AutocompleteProps) => {
    const [needToShowSuggests, setNeedToShowSuggests] = React.useState(false);
    const autocompleteRef =
      React.useRef() as React.MutableRefObject<HTMLDivElement>;

    const handleOutsideClick = React.useCallback(() => {
      if (needToShowSuggests && onCloseSuggests) {
        onCloseSuggests();
      }
      setNeedToShowSuggests(false);
    }, [needToShowSuggests, onCloseSuggests]);

    useOutsideClick(autocompleteRef, handleOutsideClick);

    React.useEffect(() => {
      if (suggestions && suggestions.length > 0) {
        setNeedToShowSuggests(true);
      }
    }, [suggestions]);

    const onSelectSuggest = React.useCallback(
      (suggestion: Suggestion) => {
        onSelect(suggestion);
        setNeedToShowSuggests(false);
      },
      [onSelect]
    );

    return (
      <div
        className={classNames(className, "Autocomplete")}
        ref={autocompleteRef}
      >
        <Input
          className={inputClassName}
          placeholder={placeholder}
          onChange={onChange}
          value={inputValue}
        />
        {needToShowSuggests ? (
          <Suggestions
            suggestions={suggestions}
            onClick={onSelectSuggest}
            suggestionRenderer={suggestionRenderer}
          />
        ) : null}
      </div>
    );
  }
);

export default Autocomplete;
